import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { Table } from "common/data/table";

export function doorPlacementsOnLevel(
  levelId: string,
  doorPlacements: Table<GeneratedDoorPlacement>,
): GeneratedDoorPlacement[] {
  const a: GeneratedDoorPlacement[] = [];
  for (const id in doorPlacements) {
    const door = doorPlacements[id];
    if (door.frontRoom?.level.id === levelId || door.backRoom?.level.id === levelId) {
      a.push(door);
    }
  }
  return a;
}
